import { toPrintSrc } from './toPrintSrc';

export function collectPrintUrls(): string[] {
  const urls = new Set<string>();

  // Select all images inside <main>.
  // For <picture> elements the browser has already resolved the best source via currentSrc.
  // For our Image component, img.src may still be the low-res placeholder — strip w/q to get full-res.
  document.querySelectorAll<HTMLImageElement>('main img').forEach(img => {
    const imageSrc = img.closest('picture') ? img.currentSrc || img.src : toPrintSrc(img.src);

    if (imageSrc) {
      urls.add(imageSrc);
    }
  });

  return [...urls].filter(Boolean);
}
